import { Link } from "react-router-dom";

import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { Row } from "Components/shared/Flexbox";

import styles from "./CampaignLink.module.scss";

export function CampaignLink({ to, text }: { to: string; text: string }) {
    return (
        <Link to={to} className={styles.link} target="_blank" rel="noopener noreferrer">
            <Row gap={1} alignItems="center">
                {text}
                <RVIcon icon="expand" size={RVIconSizeOptions.SMALL} />
            </Row>
        </Link>
    );
}
